import { runtimeConfig } from "./runtime-config";

const RUNTIME_CONFIG = runtimeConfig();

/** Public launch controls. Keep unfinished programmes out of navigation and direct routes. */
export const STAKING_ENABLED = RUNTIME_CONFIG.stakingEnabled;

/**
 * Whether the operator has opened migration transactions.
 *
 * A hint for what to render before a wallet is connected, not a permission —
 * see the field comment in `runtime-config.ts` and the module note in
 * `migration-state.ts`. The server refuses independently.
 */
export const MIGRATION_ACTIONS_ENABLED = RUNTIME_CONFIG.migrationActionsEnabled;

/** Raw units AsetquSwap must hold before migrating can open (Scheme 1, D-045). */
export const MIGRATION_REQUIRED_POOL_RAW = RUNTIME_CONFIG.migrationRequiredPoolRaw;
